// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__WiXCO","content":"LoadingAlert_content__iRzTQ"};